<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

    export default {
        name: 'App',
        created() {

            //   在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem('state')) {
                this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('state'))))
            }

            //   页面刷新时将state数据存储到sessionStorage中
            window.addEventListener('beforeunload', () => {
                sessionStorage.setItem('state', JSON.stringify(this.$store.state))
            })

        }
    }

</script>

<style lang='scss'>
    @import 'assets/styles/cover-element.scss';
    html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
    }

    #app {
        width: 100%;
        height: 100%;
        background-color: #eee;
        overflow: hidden;
    }

</style>
